<script>
import FilesWindow from '../Windows/Files';
import TextWindow from '../Windows/Text';

export default {
    data() {
        return {
            windows: {},
            filesUrlPrefix: ''
        };
    },
    beforeCreate() {
        Vue.prototype.$windows = new Proxy(this, {
            get: (target, prop) => {
                if(this.$refs.windows && prop in this.$refs.windows) {
                    return this.$refs.windows[prop];
                }

                return prop in target ? target[prop] : undefined;
            }
        });
    },
    methods: {
        showFilesWindow(titleOrFiles, files = null, index = null, triggerEvent = null, size = "full-space") {
            let title = titleOrFiles;

            if(files instanceof Event) {
                triggerEvent = files;
                files = null;
            } else if(typeof files == 'number') {
                index = files;
                files = null;
            }

            if(index instanceof Event) {
                triggerEvent = index;
                index = null;
            }

            if(!files && title && typeof title != 'string') {
                files = title;
                title = '';
            }

            this.windows.showWindow(FilesWindow, {
                title,
                files,
                initialIndex: index === null ? 0 : index,
                urlPrefix: this.filesUrlPrefix,
                size: size
            }, {}, {
                triggerElement: triggerEvent ? triggerEvent.target : null
            });
        },
        showTextWindow(text, title = '', size = 'full', triggerEvent = null) {
            if(triggerEvent == null) {
                if(typeof title != 'string') {
                    triggerEvent = title;
                    title = '';
                } else if(typeof size != 'string') {
                    triggerEvent = size;
                    size = 'full';
                }
            }

            this.windows.showWindow(TextWindow, { size, title, text }, triggerEvent ? triggerEvent.target : null);
        }
    }
}
</script>